import { FC, PropsWithChildren, useEffect } from 'react';
import { EventArgs } from 'react-ga';

import { AnalyticsEvent, AnalyticsEventKey } from 'app/services/analytics/events';

// Import directly from useAnalytics to avoid circular dependency with index.ts barrel export
import { useAnalytics } from './useAnalytics';
import { gaTrackEvent } from '../google-analytics';

// Local Typings
interface Props {
  analyticsEvent: AnalyticsEvent;
  gaEventArgOverrides?: Partial<EventArgs>;
  gaEventKey: AnalyticsEventKey;
}

// Component Definition
export const AnalyticsEventTriggerOnMount: FC<PropsWithChildren<Props>> = ({
  analyticsEvent,
  children,
  gaEventArgOverrides,
  gaEventKey,
}) => {
  const reportAnalytics = useAnalytics();

  useEffect(() => {
    reportAnalytics(analyticsEvent);
    gaTrackEvent(gaEventKey, gaEventArgOverrides);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {children}
    </>
  );
};
